import { ComponentInternalInstance, getCurrentInstance, onUnmounted, ref, Ref } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import store from '@/renderer/store';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import { SMH } from '@/renderer/scripts/smh';

/**
 * 个人空间的抽屉处理逻辑
 * @param defaultDrawerParams
 * @param spaceId
 */
export const personalSpaceDrawerHandler = (spaceId: Ref<string> = ref('')) => {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;

  // 个人空间的静态页不需要外界传递
  const emptyDrawerParams = {
    totalMsg: i18n_t('共有0个文件'),
    title: i18n_t('查看详情信息'),
    desc: i18n_t('选中文件/文件夹查看更详细信息'),
    imgClass: '',
  };

  // 当数据全部加载完毕
  const setTotal = (total: number) => {
    store.commit(DrawerEvents.SET_TOTAL, total);
  };
  // 初始化的时候，立刻初始化详情组件
  const emptyScope: Drawer.EmptyScope = {
    title: '',
    componentName: 'EmptyDetail',
    params: emptyDrawerParams,
  };
  const setDefaultDrawer = () => {
    vm.$store.commit(DrawerEvents.SET_DRAWERS, [emptyScope]);
  };

  // 数据改变时的代码块
  const selectedChangeFn = (selectedList: SMH.SpaceFileItemData[]) => {
    if (selectedList.length === 0) {
      setDefaultDrawer();
    }
    if (selectedList.length === 1) {
      // 初始化的时候，立刻初始化详情组件
      const detailScope: Drawer.DetailScope<SMH.SpaceFileItemData> = {
        title: i18n_t('详细信息'),
        componentName: 'Detail',
        // 个人版本的spaceId会自动传递
        params: {
          selectedItem: selectedList[0],
          spaceId: spaceId.value,
        },
      };
      const dynamicScope: Drawer.DynamicScope<SMH.SpaceFileItemData> = {
        title: i18n_t('动态'),
        componentName: 'Dynamic',
        // 个人版本的spaceId 传递为空字符
        params: {
          selectedItem: selectedList[0],
          spaceId: spaceId.value,
        },
      };
      const historyScope: Drawer.HistoryScope<SMH.SpaceFileItemData> = {
        title: i18n_t('历史版本'),
        componentName: 'History',
        // 个人版本的spaceId 传递为空字符
        params: {
          selectedItem: selectedList[0],
          spaceId: spaceId.value,
        },
      };
      const authScope: Drawer.AuthScope<SMH.SpaceFileItemData> = {
        title: i18n_t('共享管理'),
        componentName: 'FileMemberManage',
        // 个人版本的spaceId 传递为空字符
        params: {
          selectedItem: selectedList[0],
          spaceId: spaceId.value,
        },
      };
      // 个人空间
      let tabs = [];
      if (selectedList[0].type === 'dir') {
        // 当选择的文件/文件夹是共享文件才展示共享管理
        tabs = selectedList[0].isAuthorized ? [detailScope, dynamicScope, authScope] : [detailScope, dynamicScope];
      } else {
        tabs = selectedList[0].isAuthorized ? [detailScope, historyScope, authScope] : [detailScope, historyScope];
      }
      vm.$store.commit(DrawerEvents.SET_DRAWERS, tabs);
    }
    if (selectedList.length > 1) {
      setDefaultDrawer();
    }
  };
  ipc.on(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, setTotal);
  ipc.on(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, selectedChangeFn);
  // 事件卸载
  onUnmounted(() => {
    ipc.off(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, selectedChangeFn);
    ipc.off(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, setTotal);
  });
  return {
    setDefaultDrawer,
  };
};
